import { render, staticRenderFns } from "./MbInputErrors.vue?vue&type=template&id=c702d29e&"
import script from "./MbInputErrors.vue?vue&type=script&lang=js&"
export * from "./MbInputErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports